// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2T3lK","col":"styles_col__1nIUL"};